const IconArrowDown = ({
  width = 16,
  color = '#697586',
  ...props
}) => {
  return <svg width={width} height={width} color={color} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props} data-sentry-element="svg" data-sentry-component="IconArrowDown" data-sentry-source-file="IconArrowDown.tsx">
      <path d='M12.6666 6.00006L8.82483 9.67459C8.37113 10.1086 7.62871 10.1086 7.175 9.67459L3.33325 6.00006' stroke='currentColor' strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round' data-sentry-element="path" data-sentry-source-file="IconArrowDown.tsx" />
    </svg>;
};
export default IconArrowDown;